import React, { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import useTranslation from "../../i18n/useTranslation";

const LINK_ORGANIZATION_INVITE = gql`
    mutation LinkOrganizationInvite ($organizationId: Int!, $seasonId: Int, $isManager: Boolean) {
        linkOrganizationInvite(organizationId: $organizationId, seasonId: $seasonId, isManager: $isManager) {
            inviteLink
        }
    }
`;

const InviteLinkBox = ({ organizationId, seasonId }) => {
    const { t } = useTranslation();
    const [getTeamInviteLink] = useMutation(LINK_ORGANIZATION_INVITE);
    const [inviteURL, setInviteURL] = useState("");

    useEffect(() => {
        if (organizationId && seasonId) {
            getTeamInviteLink({
                variables: { organizationId, seasonId, isManager: true }
            }).then(({ data }) => {
                if (data?.linkOrganizationInvite?.inviteLink) {
                    setInviteURL(data.linkOrganizationInvite.inviteLink);
                }
            });
        }
    }, [organizationId, seasonId, getTeamInviteLink]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inviteURL);
        } catch (err) {
            toast.error(t("errors.somethingWentWrong"), {
                autoClose: 3000,
                toastId: "link_error",
                position: "top-center",
                closeOnClick: true,
            });
        }
    };

    const handleEmail = () => {
        const subject = encodeURIComponent(t("inviteLinkBox.emailSubject"));
        const body = encodeURIComponent(
            t("inviteLinkBox.emailBody", { inviteURL })
        );
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
    };

    const handleWhatsApp = () => {
        const message = encodeURIComponent(
            t("inviteLinkBox.whatsAppMessage", { inviteURL })
        );
        window.open(`https://web.whatsapp.com/send?text=${message}`, "_blank");
    };

    return (
        <div className="alert alert-info alert-dismissible">
            <h5>
                <i className="icon fas fa-exclamation-triangle"></i>{" "}
                <b>{t("inviteLinkBox.title")}</b>
            </h5>

            <p style={{ fontSize: "1.2rem" }}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t("inviteLinkBox.description"),
                    }}
                />
            </p>

            <div className="card-body">
                <button
                    className="btn btn-outline-kbola mr-2"
                    onClick={handleCopy}
                    type="button"
                >
                    {t("inviteLinkBox.copyLink")}
                </button>

                <button
                    className="btn btn-outline-kbola mr-2"
                    onClick={handleEmail}
                    type="button"
                >
                    {t("inviteLinkBox.sendEmail")}
                </button>

                <button
                    className="btn btn-outline-kbola mr-2"
                    onClick={handleWhatsApp}
                    type="button"
                >
                    {t("inviteLinkBox.whatsApp")}
                </button>
            </div>

            <p style={{ fontSize: "1.0rem" }}>
                <i className="icon fas fa-exclamation-triangle"></i>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t("inviteLinkBox.important"),
                    }}
                />
            </p>
        </div>
    );
};

export default InviteLinkBox;
